// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3vIXB","inner":"Footer_inner__1nuXf","nextIcon":"Footer_nextIcon__2TrrX","innerLeft":"Footer_innerLeft__2UXlg"};